module.exports = __webpack_public_path__ + "static/media/publish-simultaneous-tablet-es.0ac8b720.png";